/**
 * 试卷
 */

export const ExamResultList = [{
    prop: "id",
    label: "id",
    width: "150",
    format: "",
    order: false,
    isShow: false,
  }, {
    prop: "phone",
    label: "手机号",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  }, {
    prop: "userName",
    label: "考试成员",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },{
    prop: "isPass",
    label: "是否合格",
    width: "150",
    format: "isPass",
    order: false,
    isShow: true,
  },
  {
    prop: "examName",
    label: "试卷名称",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "score",
    label: "考试分数",
    width: "150",
    format: "",
    order: false,
    isShow: true,
  },
  {
    prop: "creationTime",
    label: "考试时间",
    format: "datetime",
    width: "150",
    isShow: true
  }
];